import React from 'react';
import axios from 'axios';
import NotificationHeader from '../Notifications/NotificationHeader';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading'
import Error from '../Components/Error'
import { Link, redirect, Navigate, useNavigate, json } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { fakeBaseQuery } from "@reduxjs/toolkit/query";


function showHideSidebar() {
  document.querySelector('.boostapp')?.classList.toggle('active');
}

const Header = () => {
  const distID = localStorage.getItem('distributorId');
  const { data, error, isLoaded } = GetRequest(`/OrderCart/GetActiveOrderCart/${distID}`);
  const navigateurl = useNavigate();

  const cartItems = data?.result?.orderCartLineItemDTOList ?? [];

  const totalQty = cartItems.reduce((sum, item) => sum + parseFloat(item.qty), 0);
  const totalCost = cartItems.reduce((sum, item) => sum + parseFloat(item.cost), 0);

  const handleCloseModalOrderIsBeingSaved = () => {
    document.getElementById('divOrderIsBeingSaved').style.display = 'none';
    document.getElementById('divOrderIsBeingSaved').classList.add('hide');
    document.getElementById('divOrderIsBeingSaved').classList.remove('show');
  }

  const handleSubmitOrder = (event, chkDT) => {

    event.preventDefault();

    if (data === null || data.result === null || data.result.orderCartLineItemDTOList === null || data.result.orderCartLineItemDTOList.length === 0) {
      document.getElementById('divModalNoItemsInOrderCart').style.display = 'block';
      document.getElementById('divModalNoItemsInOrderCart').classList.add('show');
      return;
    }



    // modalWarnClose();
    const fData = {};
    fData.distributorId = parseInt(distID);

    document.getElementById('divOrderIsBeingSaved').style.display = 'block';
    document.getElementById('divOrderIsBeingSaved').classList.add('show');

    axios.post("https://ecomplatformapi.erelatelabs.com/api/Orders/SubmitOrder", fData, {
      headers: {
        "Cache-Control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        'Authorization': localStorage.getItem("loginToken"),
      },
    })
      .then((response) => {
        handleCloseModalOrderIsBeingSaved();
        if (response.data.isSuccess === true) {
          //   tostDismissAll();
          //  notifySuccess();
          localStorage.setItem("ditsCurrentOrderLineId", response.data.result.orderLineId);
          localStorage.removeItem('activeCartData');
          redirect("/OrderTransactionDetails");
          <Navigate to="/OrderTransactionDetails" />;
          navigateurl('/OrderTransactionDetails', { replace: true });
        }
        else {
          alert("Error while submitting order. - " + response.data.message + "-Error Code - " + response.data.errorCode);
        }
        modalWarnClose();
      }).catch((error) => {
        handleCloseModalOrderIsBeingSaved();
        console.log("Logging Error");
        console.log(error);
        alert("Error while submitting order, Please try again." + error.code + "-" + error.response.status);

        tostDismissAll();
        modalWarnClose();

      });

  }
  const tostDismissAll = () => toast.clearWaitingQueue();

  const modalWarnClose = () => {
    document.getElementById('showSubmitOrderDetailedModal').style.display = 'none';
    document.getElementById('showSubmitOrderDetailedModal').classList.add('hide');
    document.getElementById('showSubmitOrderDetailedModal').classList.remove('show');
  }

  return (
    <nav className="main-header navbar navbar-theme navbar-fixed-top">
      <ul className="navbar-nav barIconNav">
        <li className="nav-item">
          <a className="nav-link" role="button" onClick={showHideSidebar}>
            <i className="fa fa-bars"></i>
          </a>
        </li>
      </ul>

      <ul className="navbar-nav navbar-right dpUI">
        <li className="nav-item">
          <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
            <i className="fa fa-bell"></i>
            <span className="badge badge-danger navbar-badge" id="notificationCountHead"></span>
          </a>
          <div className="dropdown-menu">
            <NotificationHeader />
          </div>
        </li>

        <li className="nav-item dropdown">
          <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
            <i className="fa fa-shopping-cart"></i>
            <span className="badge badge-danger navbar-badge">
              {cartItems.length}
            </span>
          </a>
          <div className="dropdown-menu" style={{ minWidth: '350px', padding: '10px' }}>
            <p style={{ textAlign: 'center' }}><b>Cart List</b></p>

            {cartItems.length > 0 ? (
              <>
                {cartItems.map((item) => (
                  <div className='row sepLn' key={item.orderCartLineItemId} id={`forRemove${item.orderCartLineItemId}`} data-state-id={item.productItemId}>
                    <div className='col-sm-3'><p>{item.productName}</p></div>
                    <div className='col-sm-3'>
                      <div className="d-flex flex-row">
                        {/* <button className="btn text-danger" id={item.orderCartLineItemId} data-val-productItemId={item.productItemId}>
                          <i className="fa fa-minus"></i>
                        </button> */}
                        <input name="quantity" value={item.qty} type="number" className="form-control qtyW50" />
                        {/* <button className="btn text-primary" id={item.orderCartLineItemId} data-val-productItemId={item.productItemId}>
                          <i className="fa fa-plus"></i>
                        </button> */}
                      </div>
                      <span className="fa fa-close deleteCartOrderItem" id={item.orderCartLineItemId} data-val-productItemId={item.productItemId}></span>
                    </div>
                    <div className='col-sm-2'><p>Rate - {item.rate} Rs</p></div>
                    <div className='col-sm-4'><p>Total - <b>{item.cost}</b> Rs</p></div>
                  </div>
                ))}
                <form onSubmit={handleSubmitOrder} >
                  <ul className="list-group mt-2">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Qty:
                      <span className="badge badge-pill" style={{ color: 'red' }}>{totalQty}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Total Cost:
                      <span className="badge badge-pill" style={{ color: 'red' }}>{totalCost} Rs</span>
                    </li>
                    <li className="list-group-item text-center">
                      <button className="btn btn-primary btn-sm">Checkout</button>
                    </li>
                  </ul>
                </form>
              </>
            ) : (
              <p className="text-center text-muted">No items in cart.</p>
            )}
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
